import type { RichTextCustomLeaf } from '../../../types.js'

export const bold: RichTextCustomLeaf = {
  name: 'bold',
  Button: '@payloadcms/richtext-slate/client#BoldLeafButton',
  Leaf: '@payloadcms/richtext-slate/client#BoldLeaf',
}
